import { useState } from 'react'
import Image from 'next/image'
import Link from 'next/link'

import NotchedCard from '~/components/NotchedCard'

export default function ImageDoubleCard({
  imageSrc,
  imageSrcMobile,
  card1,
  card1Style,
  card2,
  card2Style,
  imageNegativeTopMargin
}) {
  return (
    <div className="relative md:overflow-hidden ">
      <div className="hidden xl:block ">
        <Image
          src={imageSrc}
          alt="MaryAG FAQ"
          width="160%"
          height="90%"
          layout="responsive"
          objectFit="cover"
          className="aspect-w-16 aspect-h-9"
        />
      </div>
      <div className="hidden md:block xl:hidden">
        <Image
          src={imageSrc}
          alt="MaryAG FAQ"
          width="100%"
          height="100%"
          layout="responsive"
          objectFit="cover"
          className="aspect-w-1 aspect-h-1"
        />
      </div>

      <div className="flex flex-row justify-end flex-wrap md:absolute bottom-0 right-0 relative">
        <div className={`md:hidden absolute inset-0 ${imageNegativeTopMargin}`}>
          <Image
            src={imageSrcMobile}
            alt="MaryAG FAQ"
            width="100%"
            height="133%"
            layout="responsive"
            objectFit="cover"
            className="aspect-w-3 aspect-h-4"
          />
        </div>
        <NotchedCard
          notchPosition="top-left"
          className={card1Style}
          aspectW={660}
          aspectH={360}
        >
          {card1}
        </NotchedCard>
        <NotchedCard
          notchPosition="top-left"
          className={card2Style}
          aspectW={660}
          aspectH={360}
        >
          {card2}
        </NotchedCard>
      </div>
    </div>
  )
}
